module.exports = __webpack_public_path__ + "img/1820ce9fbb68ae15fc42117402879ca2.svg";